export default "__VITE_ASSET__DL5tBZpc__"